import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

import { telegramClientApi } from '@/shared/api';
import { GetLeaderboardResponseType } from '@/entities';

export interface LeaderboardState extends GetLeaderboardResponseType {
  loading: boolean;
  error: string | null;
}

const initialState: LeaderboardState = {
  user_rank: null,
  offset: 0,
  leaderboard: [],
  count: 0,
  limit: 30,
  loading: false,
  error: null
};

export const fetchLeaderboard = createAsyncThunk<
  GetLeaderboardResponseType,
  { offset?: number; limit?: number },
  { rejectValue: string }
>('leaderboard/fetchLeaderboard', async ({ offset, limit }, { rejectWithValue }) => {
  try {
    const res = await telegramClientApi.getLeaderboardData(offset || 0, limit || 30);
    if (res.error === null && res.data) {
      return res.data;
    } else {
      return rejectWithValue(res.error?.message || 'Failed to fetch leaderboard');
    }
  } catch (error: any) {
    return rejectWithValue(error?.message || 'Unknown error');
  }
});

const slice = createSlice({
  name: 'leaderboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLeaderboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLeaderboard.fulfilled, (state, action) => {
        if (action.payload.offset === 0) {
          state.leaderboard = action.payload.leaderboard;
        } else {
          state.leaderboard = [...(state.leaderboard || []), ...action.payload.leaderboard];
        }
        state.loading = false;
        state.user_rank = action.payload.user_rank;
        state.count = action.payload.count;
      })
      .addCase(fetchLeaderboard.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default slice.reducer;
